import { filter, get, includes, map } from "lodash";
import type { RootState } from "types/state";

// The user slice types these arrays shallowly as `Array<Record<string,
// unknown>>` by design (the Redux layer is scheduled for deletion, so it isn't
// modeled deeper). lodash `get` with a string path also widens to `unknown`, so
// cast to the fields this selector actually reads once at the boundary.
interface EmployerLinkLike {
  company: { id?: string | null };
  status?: string | null;
}

export const getLinkedEmployersSelector = (state: RootState) => {
  const linkedEmployers = get(
    state,
    "user.linkedEmployers",
    []
  ) as EmployerLinkLike[];
  const pendingEmployerLinks = get(
    state,
    "user.employerLinkRequests",
    []
  ) as EmployerLinkLike[];
  const linkedCompanies = map(linkedEmployers, "company.id");
  const pendingEmployerRequests = filter(
    pendingEmployerLinks,
    (link) =>
      !includes(linkedCompanies, link.company.id) && link.status !== "ACTIVE"
  );

  const allEmployers = [...pendingEmployerRequests, ...linkedEmployers];
  return allEmployers;
};
